import { IOrderItem } from './types'

export const orderReviewItems: IOrderItem[] = [
  {
    id: 'event',
    title: 'EVENT',
    value: '',
  },
  {
    id: 'ticketType',
    title: 'TICKET TYPE',
    value: 'First RELEASE',
  },
  {
    id: 'numberOfTickets',
    title: 'NUMBER OF TICKETS',
    value: '',
  },
  {
    id: 'price',
    title: 'PRICE PER TICKET',
    value: '',
  },
  {
    id: 'total',
    title: 'TOTAL',
    value: '',
  },
]
